import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state = () => ({
  goldTraderPresent: {},
  goldHistoryList: [],
  goldHistoryGraph: [],
  goldPeriod: {
      range: ['1D', '5D', '1W', '1M', '3M', '6M', 'YTD', '1Y', '3Y', '5Y', '10Y', 'MAX'],
      default: "1Y"
  },
  currentPeriod: "1Y",
  goldSpotLastQuote: [],
  goldSpotLastTrade: {},
  goldSpotRealtimeGraph: [],
  goldSpotHistoryGraph: [],
  goldSpotRealtimeCurrentPeriod: "1D",
  goldSpotRealtimePeriod: {
      range: ['1m', '5m', '15m', '1h', '12h', '1D', '1W', '1M', '3M', '6M', 'YTD', '1Y', '5Y', '10Y', 'MAX'],
      default: "1D"
  },
  goldSpotHistoryCurrentPeriod: "5D",
  goldSpotHistoryPeriod: {
      range: ['5D', '1M', '3M', '6M', 'YTD', '1Y', '5Y', '10Y'],
      default: "5D"
  },
  goldSpotPreviousClose: [],
  goldSpotLastPrice: null,
  globalConfiguration: [],
  // gold spot thai
  goldSpotThaiRealtimeGraph: [],
  goldTraderRealtimeGraph: [],
  goldSpotThaiRealtimeCurrentPeriod: "1D",
  goldSpotThaiRealtimePeriod: {
      range: ['1m', '5m', '15m', '1h', '12h', '1D', '1W', '1M', '3M'],
      default: "1D"
  },
  goldSpotThaiLastPrice: null
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
